import { DesignEntity } from '@/lib/enums';

const mapEntityOptions = (entities, level, includeNested, derive) => {
  const map = new Map();

  Object.values(entities ?? {}).forEach((entity) => {
    if (!derive) {
      map.set(entity.uuid, entity);
      return;
    }

    const derived = entity.derived;
    derived.__metrics = {
      managed: derived?.__metrics?.managed
        ? { ...derived?.__metrics?.managed }
        : {},
      self: derived?.__metrics?.self ? { ...derived?.__metrics?.self } : {},
      span: derived?.__metrics?.span ? { ...derived?.__metrics?.span } : {},
    };
    map.set(entity.uuid, derived);
  });

  return map;
};

export default function mapDesign(
  design,
  snapshot,
  level,
  includeNested,
  includeDerived
) {
  if (!snapshot) {
    return null;
  }

  return new Map([
    [DesignEntity.ORGANISATION, design],
    [
      DesignEntity.PERSON,
      mapEntityOptions(
        snapshot.entities.people,
        level,
        includeNested,
        includeDerived
      ),
    ],
    [
      DesignEntity.GROUP,
      mapEntityOptions(
        snapshot.entities.groups,
        level,
        includeNested,
        includeDerived
      ),
    ],
    [
      DesignEntity.ROLE,
      mapEntityOptions(
        snapshot.entities.roles,
        level,
        includeNested,
        includeDerived
      ),
    ],
    [
      DesignEntity.MANAGER,
      mapEntityOptions(
        snapshot.entities.roles,
        level,
        includeNested,
        includeDerived
      ),
    ],
    [
      DesignEntity.ACTIVITY,
      mapEntityOptions(
        snapshot.entities.activities,
        level,
        includeNested,
        includeDerived
      ),
    ],
  ]);
}
